<template>
  <div class="list-box-container">
    <template>
      <div class="d-flex list-box-header col-12 pointer" @click="$emit('editServer')">
        <div class="pl-0 list-box-header-left col-lg-9 col-12 pr-3">
          <div class="pl-0 d-flex align-items-center col-lg-4 col-12">
            <div class="claim-customer col-12 wrap">
              <span class="full-name">{{ server.mail_username }}</span>
            </div>
          </div>
          <div class="d-flex align-items-center col-lg-8 col-12">
            <span v-for="company in companies" :key="company.id"><span v-if="company.id === server.company_id">{{ company.name }}</span></span>
          </div>
        </div>
        <div class="list-box-header-right col-lg-3 col-12 pl-4">
          <label />
          <div class="d-flex align-items-center col-12 mail-host">
            {{ server.mail_host }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    server: {
      type: Object,
      default: () => {},
    },
    companies: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.list-box-status {
  align-items: normal;
}
.full-name {
  font-weight: 500;
  font-size: 16px;
  color: #4c5669;
}
.list-box-header {
  min-height: 66px;
}
@media only screen and (max-width: 768px) {
  .full-name {
    font-size: 12px;
  }
  .list-box-header-left {
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
  }
  .list-box-header-right {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Mailing/SmtpServersBlock.vue